import { createRoot } from "react-dom/client";
import { ConvexProvider, ConvexReactClient } from "convex/react";
import App from "./App";
import AdminGate from "./components/AdminGate";
import AdminPage from "./pages/AdminPage";
import TryOnPage from "./pages/TryOnPage";
import TermsPage from "./pages/TermsPage";
import { I18nProvider } from "./i18n";
import "./styles/main.css";

// CONVEX_URL is public and safe to expose
const CONVEX_URL = "https://rightful-bullfrog-870.convex.cloud";

const convex = new ConvexReactClient(CONVEX_URL);

// Version check - reload page when new build is deployed (production only)
if (location.hostname !== "localhost") {
  (async () => {
    try {
      const initialVersion = await fetch("/api/version").then((r) => r.text());
      setInterval(async () => {
        try {
          const currentVersion = await fetch("/api/version").then((r) => r.text());
          if (currentVersion !== initialVersion) {
            location.reload();
          }
        } catch {
          // Server might be restarting, ignore
        }
      }, 30000);
    } catch {
      // Version endpoint not available, skip polling
    }
  })();
}

// Minimal pathname router: /admin → admin, /t/:code → try-on page, else main app
function Router() {
  const path = location.pathname;
  if (path === "/admin")
    return (
      <AdminGate>
        <AdminPage />
      </AdminGate>
    );
  if (path === "/terms") return <TermsPage />;
  const tryOnMatch = path.match(/^\/t\/([a-z0-9]+)$/);
  if (tryOnMatch?.[1]) return <TryOnPage code={tryOnMatch[1]} />;
  return (
    <AdminGate>
      <App />
    </AdminGate>
  );
}

const root = createRoot(document.getElementById("root")!);
root.render(
  <ConvexProvider client={convex}>
    <I18nProvider>
      <Router />
    </I18nProvider>
  </ConvexProvider>
);
